import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { Container } from "react-bootstrap";
import { Row, Col, Card } from "react-bootstrap";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Evaluation({
  visible,
  newM,
  setNewM,
  setMoamad,
  moamad,
  uEmail,
}) {
  const [displaySave, setDisplaySave] = useState(true);

  const [userEmail, setUserEmail] = useState(null);
  const [megdarOptions, setMegdarOptions] = useState([]);
  const [famOptions, setFamOptions] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "megdartype/", {
          signal: controller.signal,
        });
        setMegdarOptions(response.data[0].megdarOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
      try {
        const response = await axiosPrivate.get(baseURL + "famtype/", {
          signal: controller.signal,
        });
        setFamOptions(response.data[0].famOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setUserEmail(uEmail);
  }, []);

  const handleChange = (e) => {
    const { name, type } = e.target;
    if (type == "checkbox") {
      const { checked } = e.target;
      const checkedValue = checked ? 1 : 0;
      setNewM((prevState) => ({
        ...prevState,
        [name]: checkedValue,
      }));
    } else {
      const { value } = e.target;
      setNewM((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    setDisplaySave(false);
  };

  const handleCheckBoxChange = (e) => {
    const { name, value } = e.target;
    setNewM((prevState) => ({
      ...prevState,
      [name]: e.target.checked,
    }));
    setDisplaySave(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          "/jobs/moamad/" + newM.id + "/",
          newM,
          {
            signal: controller.signal,
          }
        );

        isMounted && setNewM(response.data);

        alert("העדכון בוצע בהצלחה");
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    saveData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
    setDisplaySave(true);
  };

  const handleNevdak = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          "/jobs/moamad/" + newM.id + "/",
          newM,
          {
            signal: controller.signal,
          }
        );

        isMounted && setNewM(response.data);

        alert("העדכון בוצע בהצלחה");
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    saveData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
    setDisplaySave(true);
  };

  if (!visible) return;
  return (
    <Card className="border-danger container px-5 " bg="light">
      <Card.Header>
        <h3>
          הערכת המועמד{" "}
          {newM.f_name +
            " " +
            (newM.father_name ? newM.father_name + " " : "") +
            " " +
            newM.l_name}
        </h3>
      </Card.Header>
      <Card.Body>
        <form onSubmit={handleSubmit}>
          <Container className="col-sm-10">
            <Row>
              <Col>
                <div className="form-group" style={{ textAlign: "right" }}>
                  <input
                    type="checkbox"
                    id="amida_haskala"
                    name="amida_haskala"
                    checked={newM.amida_haskala == 1 ? true : false}
                    value={newM.amida_haskala}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="amida_haskala"
                    style={{ marginRight: "10px" }}
                  >
                    עמידה בתנאי ההשכלה?
                  </label>
                </div>
              </Col>
              <Col>
                <div className="form-group" style={{ textAlign: "right" }}>
                  <input
                    type="checkbox"
                    id="amida_meksoey"
                    name="amida_meksoey"
                    checked={newM.amida_meksoey == 1 ? true : false}
                    value={newM.amida_meksoey}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="amida_meksoey"
                    style={{ marginRight: "10px" }}
                  >
                    עמידה בתנאי נסיון מקצועי?{" "}
                  </label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form-group" style={{ textAlign: "right" }}>
                  <input
                    type="checkbox"
                    id="amida_neholy"
                    name="amida_neholy"
                    checked={newM.amida_neholy == 1 ? true : false}
                    value={newM.amida_neholy}
                    onChange={handleCheckBoxChange}
                  />
                  <label htmlFor="amida_neholy" style={{ marginRight: "10px" }}>
                    עמידה בתנאי ניסיון ניהולי?
                  </label>
                </div>
              </Col>

              <Col>
                <div className="form-group" style={{ textAlign: "right" }}>
                  <input
                    type="checkbox"
                    id="amida_nosafot"
                    name="amida_nosafot"
                    checked={newM.amida_nosafot == 1 ? true : false}
                    value={newM.amida_nosafot}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="amida_nosafot"
                    style={{ marginRight: "10px" }}
                  >
                    עמידה בתנאי דרישות נוספות?{" "}
                  </label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form-group" style={{ textAlign: "right" }}>
                  <input
                    type="checkbox"
                    id="saf"
                    name="saf"
                    checked={newM.saf == 1 ? true : false}
                    value={newM.saf}
                    onChange={handleCheckBoxChange}
                  />
                  <label htmlFor="saf" style={{ marginRight: "10px" }}>
                    עמידה בתנאי הסף (כללי)?
                  </label>
                </div>
              </Col>
              <Col>
                <div className="form-group" style={{ textAlign: "right" }}>
                  <input
                    type="checkbox"
                    id="accepted"
                    name="accepted"
                    checked={newM.accepted == 1 ? true : false}
                    value={newM.accepted}
                    onChange={handleCheckBoxChange}
                  />
                  <label htmlFor="saf" style={{ marginRight: "10px" }}>
                    התקבל?
                  </label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form-group">
                  <label htmlFor="ranking" style={{ marginRight: "10px" }}>
                    דירוג המועמד
                  </label>
                  <input
                    type="number"
                    name="ranking"
                    value={newM.ranking}
                    onChange={handleChange}
                    className="form-control"
                    id="ranking"
                    placeholder="כמו 3"
                  />
                </div>
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <div className="form-group">
                  <label htmlFor="notes" style={{ marginRight: "10px" }}>
                    הערות
                  </label>
                  <textarea
                    name="notes"
                    value={newM.notes}
                    onChange={handleChange}
                    className="form-control"
                    id="notes"
                    rows="4"
                    cols="50"
                  />
                </div>
              </Col>
            </Row>

            <br></br>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={displaySave}
            >
              שמור
            </button>
          </Container>
        </form>
      </Card.Body>
    </Card>
  );
}
